
const isDeveloppement = false
const baseURL = isDeveloppement ? 'http://localhost:5001' : 'https://www.alamiriya.com/api2';
// const baseURL = isDeveloppement ? 'http://localhost:5001' : '';


export {baseURL}